import Home from '../../spa/Home';
import NotFound from '../../spa/NotFound';

import inicialRoutes from './inicial';
import carritoRoute from './carrito';
import pagosRoute from './pagos';
import principalRoute from './principal';
import cuentaRoute from './cuenta';
import perfilRoute from './perfil';
import pedidoRoute from './pedido';
import facturaRoute from './factura';
import pedidoForm from './pedidoForm';
import facturaForm from './facturaForm';
import confirmacionRoute from './confirmacion';
import calendarRoute from './calendar';
import licenciaRoute from './licencia';
import articuloRoute from './articulo';
import recuperUsuarioRoute from './recuperaUsuario';
import loginRoute from './login';

export const routes = [{
        path: '/',
        name: 'inicio',
        component: Home,
        props: true,
        redirect: 'principal',
        children: [
            inicialRoutes,
            carritoRoute,
            pagosRoute,
            cuentaRoute,
            pedidoRoute,
            pedidoForm,
            perfilRoute,
            perfilRoute,
            confirmacionRoute,
            calendarRoute,
            facturaRoute,
            facturaForm,
            licenciaRoute,
            principalRoute,
            articuloRoute,
            recuperUsuarioRoute,
            loginRoute
        ],
    },
    {
        path: '*',
        component: NotFound,
    },
];

export const VueRouterObject = {
    routes,
    saveScrollPosition: true,
    mode: 'history'
};

export default VueRouter => new VueRouter(VueRouterObject);


// WEBPACK FOOTER //
// ./src/config/router/index.js